import { TRootState } from '@/redux/rootReducer';

export const getRentalItems = (state: TRootState) => state.rentalItems.data;
